import { BE_ACCESS_TOKEN_LOCALSTORAGE_KEY } from 'hooks/useCurrentUser'

// Kept for backward-compat — some callers import this key directly.
export const OKTA_TOKE_LOCALSTORAGE_KEY = 'okta-token-storage'

const getAuthToken = (): string | null => {
  return (
    JSON.parse(localStorage.getItem(BE_ACCESS_TOKEN_LOCALSTORAGE_KEY) || '{}')
      .accessToken ?? null
  )
}

export const getWishList = async () => {
  try {
    const token = getAuthToken()
    if (!token) return []

    const raw = await fetch(
      `${import.meta.env.VITE_BACKEND_URL}/api/wishlist`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      }
    )
    const response = await raw.json()
    return response?.templateIds ?? []
  } catch (error) {
    return []
  }
}

export const upsertWishlist = async (ids: number[]) => {
  const token = getAuthToken()
  if (!token) return

  const raw = await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/wishlist`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ templateIds: ids })
  })
  const response = await raw.json()
  return response?.templateIds
}
